export default Object.freeze({
  MONTHLY: 'monthly',
  ANNUAL: 'annual'
})



// WEBPACK FOOTER //
// ./src/constants/registration/planIntervals.js